import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { IProductDataV3 } from '@df/catalog/product/product';
import { ISizeName } from '@df/core/service/client';
import { DfModal } from '@df/ui/modal/df-modal.decorator';
import { NDfModal } from '@df/ui/modal/df-modal.interface';
import { ModalRef } from '@df/ui/modal/modal-ref';
import { MODAL_DATA } from '@df/ui/modal/modal.service';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { UiComponent } from '@df/ui/ui.component';
import { NICmsContentComponent } from '@icms/core/content';
import { XnotifFormComponent } from 'projects/app-default/src/app/module/xnotif/xnotif-form.component';
import { LocalProduct } from '../../../model/product/product.decorator';

export namespace NNotifyMeModal {
    export const BLOCK_ID = 'product-notify-me-modal';

    export interface IData {
        product: LocalProduct<IProductDataV3>;
    }
}

@DfModal({
    id: NNotifyMeModal.BLOCK_ID,
    position: (sizeId: ISizeName) => (sizeId === 'S' ? 'bottom' : undefined),
    config: (sizeId: ISizeName) => ({
        closeOnNavigation: true,
        maxWidth: sizeId === 'S' ? '100vw' : '465px',
        width: sizeId === 'S' ? '100vw' : '465px',
        position: sizeId === 'S' ? { bottom: '0' } : undefined
    }),
    blockGroup: 'modals',
    priority: 20,
    reopenPolicy: NDfModal.ReopenPolicy.last,
    sizeRestriction: sizeName => ({ S: ['S', 'M'], M: ['S', 'M'], L: ['L', 'X'], X: ['L', 'X'] })[sizeName]
})
@Component({
    selector: 'product-notify-me-modal',
    templateUrl: './product-notify-me-modal.html',
    standalone: true,
    imports: [TranslationModule, XnotifFormComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductNotifyMeModalComponent extends UiComponent implements NICmsContentComponent.IComponent, OnInit {
    protected isSuccess = false;

    constructor(
        private modalRef: ModalRef<any>,
        @Inject(MODAL_DATA) protected data: NNotifyMeModal.IData
    ) {
        super();
    }

    protected close(): void {
        this.modalRef.close();
    }

    protected onSuccess(): void {
        this.isSuccess = true;
        this.detectChanges();
    }
}
